import segmentPlugin from '@analytics/segment'
import Analytics from 'analytics'

export const analytics = Analytics({
  app: 'avantstay-manualer',
  plugins: [segmentPlugin({ writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY_HOUSE_MANUAL })],
})